import React, { useRef, useState, useCallback } from 'react'
import './style.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';

const ConsumerSay = () => {
    const sliderRef = useRef();

    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleSlideChange = (swiper) => {
        setIsBeginning(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
    };


    return (
        <>
            <div className="consumer-says-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className='home-main-heading'>What Our Consumer Say</h1>
                        </div>

                        <div className="col-md-12">
                            <div className="consumer-card-box">
                                <div className="slider-container">
                                    <Swiper
                                        slidesPerView={'4'}
                                        spaceBetween={30}
                                        navigation={false}
                                        loop={true}
                                        autoplay={{
                                            delay: 3000,
                                            disableOnInteraction: false,
                                            pauseOnMouseEnter: true,
                                        }}
                                        modules={[Navigation, Autoplay]}
                                        onSlideChange={handleSlideChange}
                                        className="mySwiper"
                                        ref={sliderRef}
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            375: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            320: {
                                                slidesPerView: 1,
                                                spaceBetween: 0,
                                            },
                                            780: {
                                                slidesPerView: 3,
                                                spaceBetween: 0,
                                            },
                                            768: {
                                                slidesPerView: 3,
                                                spaceBetween: 0,
                                            },
                                            1280: {
                                                slidesPerView: 4,
                                                spaceBetween: 0,
                                            },
                                        }}
                                    >
                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"I needed an urgent plumber and found one within minutes on I-Sit. The professional was verified, arrived on time, and fixed the issue efficiently. The whole process was simple and stress-free."</p>
                                                <h3>- Michael R., Homeowner</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"I-Sit made it easy to find a licensed electrician I could trust. The service was professional, transparent, and completed exactly as promised. I'll definitely use the platform again."</p>
                                                <h3>- Sarah M., Apartment Resident</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"I hired a certified engineer through I-Sit for a property inspection and had a great experience. The platform connects you with genuine professionals, not just random listings."</p>
                                                <h3>- Daniel K., Property Manager</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"What I like most about I-Sit is the reliability. Every professional I've booked has been verified and skilled. It saves time and gives real peace of mind."</p>
                                                <h3>- Emily W., Small Business Owner</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"Finding a reliable handyman used to be a headache. With I-Sit, I found a skilled professional who handled multiple repairs in one visit. Highly recommend this platform!"</p>
                                                <h3>- James T., Restaurant Owner</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"I was impressed by how quickly I could compare professionals and read genuine reviews. The booking process was seamless, and the HVAC technician was excellent."</p>
                                                <h3>- Lisa P., Office Manager</h3>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            <div className="comsumer-say-card">
                                                <p className="common-text">"As a first-time homeowner, I-Sit has been invaluable. From painters to cleaners, every professional has been background-checked and truly qualified. A trusted resource!"</p>
                                                <h3>- Robert H., First-Time Homeowner</h3>
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>

                                <div className="arrow-slider-box">
                                    <i onClick={handlePrev} className="fas fa-chevron-left"></i>
                                    <i onClick={handleNext} className="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConsumerSay